/** Size variant for AgentKindIcon. DEFAULT is the original fixed 36px tile / 20px orb
 *  (DoBoxRunViewPanel, DoBoxRunViewFullScreen — untouched by the DoBox agent-band work).
 *  BAND_FULL/BAND_COMPACT are AgentBand's own smaller sizes (spec: dobox-agent-band). */
export enum AgentKindIconSize {
  DEFAULT = 'DEFAULT',
  BAND_FULL = 'BAND_FULL',
  BAND_COMPACT = 'BAND_COMPACT',
  CHIP = 'CHIP',
}
